import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20Korean%20manhwa%20style%20wide%20illustration%20of%20an%20open%20book%20with%20magical%20glowing%20pages%20floating%20in%20a%20cozy%20reading%20room%20with%20warm%20golden%20sunlight%20streaming%20through%20windows%20soft%20and%20inviting%20atmosphere%20bookshelves%20in%20background%20gentle%20bokeh%20effect&width=1600&height=800&seq=cta-bg-home&orientation=landscape"
        alt="开始你的韩漫阅读之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/60" />

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4">
          准备好<strong className="text-accent-400">探索</strong>韩漫世界了吗？
        </h2>
        <p className="text-sm md:text-base text-background-100/80 mb-8 max-w-lg mx-auto">
          5000+部精选韩漫等你来读，高清画质、流畅阅读、每日更新
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="group bg-foreground-950 hover:bg-foreground-900 text-background-50 px-8 py-3.5 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200 inline-flex items-center gap-2"
          >
            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950">
              <i className="ri-book-open-line text-xs" />
            </span>
            开始阅读
            <i className="ri-arrow-right-up-line ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
          </Link>
          <Link
            to="/about"
            className="border border-background-50/50 hover:border-background-50 text-background-50 px-8 py-3.5 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}